import { toastr } from 'react-redux-toastr';
import adminDeleteBooking from './adminDeleteBooking.gql';
import {
  DELETE_BOOKING_START,
  DELETE_BOOKING_SUCCESS,
  DELETE_BOOKING_ERROR
} from '../../../constants';

export default function deleteBooking(orderId, reason) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: DELETE_BOOKING_START
    });

    try {
      let errorMessage;

      const mutation = adminDeleteBooking;

      const { data } = await client.mutate({
        mutation,
        variables: {
          orderId,
          reason
        }
      });

      if (data?.adminDeleteBooking?.status === 200) {
        dispatch({
          type: DELETE_BOOKING_SUCCESS
        });
        toastr.success('Success', `The booking has been deleted.`);
        return {
          status: 200
        };
      } else {
        dispatch({
          type: DELETE_BOOKING_ERROR
        });

        errorMessage = (data && data.adminDeleteBooking && data.adminDeleteBooking.errorMessage) || "Oops! Something went wrong. Please try again.";
        toastr.error('Error!', errorMessage);
        return {
          status: 400
        };
      }
    } catch (err) {
      toastr.error('Error!', err);
      dispatch({
        type: DELETE_BOOKING_ERROR
      });
      return {
        status: 400
      };
    }

  }
};